import React from 'react';
import './SafeArea.css';

const SafeArea = ({ children, style = {} }) => {
  return (
    <div className="safe-area" style={style}>
      {children}
    </div>
  );
};

export default SafeArea; 